import {Component, Inject, OnInit, Optional, ViewChild,} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TreeTableComponent} from '../../../acheteur/tree-table/tree-table.component';
import {Router} from '@angular/router';
import {TransferlistcheckedService} from './transferlistchecked.service';
import {LotParentArt} from '../../../acheteur/appel-offre/add-appel-offer/add-info-lot-offer/lot-offer-table/lot-offer-table.component';

function removeDuplicates(originalArray, prop) {
    var newArray = [];
    var lookupObject = {};

    for (var i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
}

export interface datainfo {
    epbimaster: string;
    id: number;
    bidNo: any;
    instBizRegNo: any;
    isgroupement: any;
    canupload: any;
    data?: any;
}

@Component({
    selector: 'app-dialog-lot-produit',
    templateUrl: './dialog-lot-produit.component.html',
    styleUrls: ['./dialog-lot-produit.component.css'],
})
export class DialogLotProduitComponent implements OnInit {
    @ViewChild(TreeTableComponent) treeTablCeomponent: TreeTableComponent;
    listchecked = [];
    show: any;
    inputData: any;

    constructor(
        private router: Router,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
        private dialog: MatDialogRef<DialogLotProduitComponent, { data: any; submit?: any }>,
        private transferlistcheckedService: TransferlistcheckedService
    ) {
        this.inputData = data;

    }

    ngOnInit(): void {

    }

    onSuccessAdd() {
        console.log('this.transferlistcheckedService.getData()', this.transferlistcheckedService.getData());
        this.dialog.close({
            data: this.transferlistcheckedService.getData(),
        });

        this.router.navigate([
            '/fournisseur/offres/particpationoffre/' +
            this.data.epbimaster +
            '/' +
            this.data.bidNo,
        ]);
    }

    listgroupement() {

        this.dialog.close({
            data: this.transferlistcheckedService.getData(),
            submit: true,
        });
        this.router.navigate(['/fournisseur/offres/Actedegroupement']);
    }

    send(data: any) {

        this.listchecked = [];
        data.forEach((x) => {

            this.listchecked.push(x);
        });
        const t = [];
        let listarticle = [];
        let obj: LotParentArt = new LotParentArt();
        this.listchecked.forEach((result) => {
            if (result.expandable) {
                obj = result;

                const child = this.treeTablCeomponent.treeControl.getDescendants(
                    result
                );
                child.forEach((x) => {
                    listarticle.push(x);
                });
                var uniqueArray2 = removeDuplicates(listarticle, 'bidCls');
                obj.listLocalArticle = uniqueArray2;
                t.push(obj);
            } else if (this.treeTablCeomponent.getParentNode(result) != null) {
                obj = this.treeTablCeomponent.getParentNode(result);

                obj.listLocalArticle = [];

                listarticle.push(result);

                var uniqueArray2 = removeDuplicates(listarticle, 'bidCls');
                obj.listLocalArticle = uniqueArray2;
                obj.listLocalArticle.forEach((x) => (x.bidModSeq = obj.bidModSeq));
                t.push(obj);
            } else {


                obj = result;
                obj.listLocalArticle = [];
                t.push(obj);

            }
        });
        var uniqueArray = removeDuplicates(t, 'bidCls');
        uniqueArray.forEach((e) => {
            const t = e.listLocalArticle.filter((x) => x.clsParentId == e.epBidClsId);
            e.listLocalArticle = t;
        });
        this.transferlistcheckedService.setData(uniqueArray);
    }

    senddatawithfile(data) {
        data.withfile = true;

        this.listchecked.push(data);

        this.transferlistcheckedService.setData(data);
        this.dialog.close({
            data: this.listchecked,
        });
        console.log('get', this.transferlistcheckedService.getData());
        this.router.navigate([
            '/fournisseur/offres/particpationoffre/' +
            this.data.epbimaster +
            '/' +
            this.data.bidNo,
        ]);
    }
}
